module.exports = __webpack_public_path__ + "static/media/no_result_car.d6c97a4b.png";